<template>
  <tr data-test="horseAppRow">
    <template v-if="$vuetify.breakpoint.mdAndUp">
      <td></td>
      <td>
        {{ item.invoiceLine.product ? item.invoiceLine.product.name : "" }}
        <div v-if="item.paymentInProcess" class="secondary--text">
          {{
            $t(
              "people:ShoppingBasket.ShoppingBasketTab.InProcess.text",
              "In process",
              "Label of the order table section"
            )
          }}
        </div>
      </td>
      <td>
        <AppShowInvoiceLineDetails :invoice-line="item.invoiceLine" />
        <slot name="notAllowedReasons" />
      </td>
      <td class="text-right"><slot name="price" /></td>
      <td><slot name="actions" /></td>
    </template>
    <template v-else>
      <td style="font-size: 12px" colspan="100%">
        <v-row dense class="align-center mb-2">
          <v-col>
            {{ item.invoiceLine.product ? item.invoiceLine.product.name : "" }}

            <div v-if="item.paymentInProcess" class="secondary--text">
              {{
                $t(
                  "people:ShoppingBasket.ShoppingBasketTab.InProcess.text",
                  "In process",
                  "Label of the order table section"
                )
              }}
            </div>
          </v-col>
          <div>
            <slot name="price" />
          </div>
        </v-row>

        <v-row dense no-gutters>
          <v-col>
            <AppShowInvoiceLineDetails :invoice-line="item.invoiceLine" />
            <slot name="notAllowedReasons" />
          </v-col>
        </v-row>
      </td>
    </template>
  </tr>
</template>
<script>
import { defineComponent } from "vue";
import gql from "fraql";

import AppShowInvoiceLineDetails from "@AppShows/AppShowInvoiceLineDetails.vue";

export default defineComponent({
  name: "InvoiceLineDetails",
  components: {
    AppShowInvoiceLineDetails
  },
  inheritAttrs: false,
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  fragments: {
    invoiceLineFields: gql`
      fragment _ on InvoiceLine {
        id
        ${AppShowInvoiceLineDetails.fragments.invoiceLineFields}
        horse {
          ${AppShowInvoiceLineDetails.fragments.horseFields}
        }
        entry {
          id
          ${AppShowInvoiceLineDetails.fragments.entryFields}
        }
        productId
        product @client {
          id
          name
        }
      }
    `
  }
});
</script>
